/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of bank details extraction from RIB document
 * @export
 * @interface BankDetailsExtractionResult
 */
export interface BankDetailsExtractionResult {
    /**
     * Extracted IBAN number
     * @type {string}
     * @memberof BankDetailsExtractionResult
     */
    iban?: string;
    /**
     * Extracted BIC/SWIFT code
     * @type {string}
     * @memberof BankDetailsExtractionResult
     */
    bic?: string;
    /**
     * Whether the extracted IBAN is valid
     * @type {boolean}
     * @memberof BankDetailsExtractionResult
     */
    isIbanValid?: boolean;
    /**
     * Whether the extracted BIC is valid
     * @type {boolean}
     * @memberof BankDetailsExtractionResult
     */
    isBicValid?: boolean;
    /**
     * Country code extracted from IBAN
     * @type {string}
     * @memberof BankDetailsExtractionResult
     */
    countryCode?: string;
    /**
     * Confidence score of the extraction (0-100)
     * @type {number}
     * @memberof BankDetailsExtractionResult
     */
    confidence?: number;
    /**
     * Error message if extraction failed
     * @type {string}
     * @memberof BankDetailsExtractionResult
     */
    errorMessage?: string | null;
    /**
     * Whether the extraction was successful
     * @type {boolean}
     * @memberof BankDetailsExtractionResult
     */
    isSuccess?: boolean;
}

/**
 * Check if a given object implements the BankDetailsExtractionResult interface.
 */
export function instanceOfBankDetailsExtractionResult(value: object): value is BankDetailsExtractionResult {
    return true;
}

export function BankDetailsExtractionResultFromJSON(json: any): BankDetailsExtractionResult {
    return BankDetailsExtractionResultFromJSONTyped(json, false);
}

export function BankDetailsExtractionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankDetailsExtractionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'iban': json['iban'] == null ? undefined : json['iban'],
        'bic': json['bic'] == null ? undefined : json['bic'],
        'isIbanValid': json['isIbanValid'] == null ? undefined : json['isIbanValid'],
        'isBicValid': json['isBicValid'] == null ? undefined : json['isBicValid'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
    };
}

export function BankDetailsExtractionResultToJSON(json: any): BankDetailsExtractionResult {
    return BankDetailsExtractionResultToJSONTyped(json, false);
}

export function BankDetailsExtractionResultToJSONTyped(value?: BankDetailsExtractionResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'iban': value['iban'],
        'bic': value['bic'],
        'isIbanValid': value['isIbanValid'],
        'isBicValid': value['isBicValid'],
        'countryCode': value['countryCode'],
        'confidence': value['confidence'],
        'errorMessage': value['errorMessage'],
        'isSuccess': value['isSuccess'],
    };
}

